export default __webpack_public_path__ + "static/media/client33.225b7aa3.png";